import React from 'react';
import { Navigate } from 'react-router-dom';
import { paths } from '@/config/paths';

interface PrivateRouteProps {
  isAuthenticated: boolean;
  children: React.ReactElement;
}

export const PrivateRoute: React.FC<PrivateRouteProps> = ({
  isAuthenticated,
  children,
}) => {
  if (!isAuthenticated) {
    return <Navigate to={paths.Login} replace />;
  }
  return children;
};
